module.exports = __webpack_public_path__ + "img/kefu.b775a057.jpg";